import { Mentorum, useMentorumMenusu, yalnizMentorumMu } from "./Mentorum";
import { onayBilgisi } from "./onay-kilidi-durumu";
import { useQueryClient } from "@tanstack/react-query";
import { OnayKilidi } from "./OnayKilidi";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { KALP_ARALIGI_MS } from "@koclukpanel/contracts";
import { BosDurum, Buton, cn, Iskelet, SayfaBasligi } from "@koclukpanel/ui";
import type { KuyrukDurumu } from "@koclukpanel/contracts";
import { oturum } from "./oturum-durumu";
import { KuyrukGondericisi } from "./cevrimdisi/gonderici";
import { SenkronKuyrugu } from "./cevrimdisi/kuyruk";
import { IndexedDbDeposu, kimlikUret } from "./cevrimdisi/indexeddb-depo";
import { karantinayiKurtar } from "./cevrimdisi/karantina";
import { useBaglantiDurumu, useOnbellektenGosteriliyor } from "./baglantiDurumu";
import { yedekKodBandi } from "./yedek-kod-uyarisi";
import type { GirisSebebi } from "./giris-sebebi";
import { hataMetni } from "./hata-metni";
import {
  api,
  AgHatasi,
  ApiHatasi,
  benGetir,
  bildirimSayaci,
  bugunkuGorevler,
  cikisYap,
  denemeKodla,
  denemelerim,
  kendiKaydim,
  mesajKutum,
  sayacBaslat,
  sayacBitir,
  sayacKalp,
  senkronGonder,
  type Ben,
  type DenemeOzeti,
  type Gorev,
  type KendiOgrenciKaydi,
  type KodlamaSonucu,
} from "./api";
import { BugunKahramani } from "./BugunKahramani";
import { Giris } from "./Giris";
import { Hesabim } from "./Hesabim";
import {
  OgrenciKabugu,
  type AnalizHedefi,
  type HesapHedefi,
  type OdulHedefi,
  type OgrenciHedefi,
} from "./Kabuk";
import { Oduller } from "./Oduller";
import { pwaDinle, pwaGuncelle, type PwaDurumu } from "./pwa";
import { GorevKarti } from "./GorevKarti";
import { CanliIzlemeBaglami, useCanliModulAcik } from "./canli-izleme";
import { gunlukOzet } from "./gunluk-ozet";
import { okumaOnbellegiTemizle } from "./pwa-onbellek";
import { VeliKabugu } from "./VeliKabugu";
import { YedekKodBandi } from "./YedekKodBandi";
import { VeriGirisi } from "./VeriGirisi";
import { Yapamadim } from "./Yapamadim";
import { Takvimim } from "./Takvimim";
import { Duyurularim } from "./Duyurularim";
import { HaftalikProgram } from "./HaftalikProgram";
import { Gelisim } from "./Gelisim";
import { DenemeListesi } from "./DenemeListesi";
import { Karne } from "./Karne";
import { DenemeNetlerim } from "./DenemeNetlerim";
import { KodlamaAc } from "./KodlamaAc";

const BOS_OZET: Record<KuyrukDurumu, number> = {
  bekliyor: 0,
  gonderiliyor: 0,
  gonderildi: 0,
  hatali: 0,
};

/** Kuyrugun otomatik denenme araligi (ms). */
const SENKRON_ARALIGI = 30_000;

interface VeriGirdisi {
  correctCount: number;
  wrongCount: number;
  emptyCount: number;
  durationSeconds: number | null;
  difficultyRating: number | null;
  studentNote: string | null;
  tamamlandi: boolean;
}

type Kip =
  | { tur: "yok" }
  | { tur: "veri"; gorev: Gorev }
  | { tur: "mazeret"; gorev: Gorev }
  | { tur: "deneme"; deneme: DenemeOzeti };

/**
 * GEZİNTİ TEK BİR HEDEFLE — sürüm 9b.
 *
 * Önceden dört ayrı durum vardı (sekme, program görünümü, Hesabım başlangıcı,
 * Gelişim/Ödüller iç seçicileri) ve bir ekrana iki yoldan gelmek onu iki farklı
 * hâlde açabiliyordu. Artık alt şerit, yan menü ve profil menüsü aynı
 * `OgrenciHedefi` adını gönderiyor (Kabuk.tsx).
 *
 * Deneme AYRI bir bölümde çünkü günlük iş DEĞİL: öğrenci onu evde, kendi
 * belirlediği zamanda çözüyor (F-EXM-13); görev listesine karıştırmak "bugün
 * yapılacaklar" listesini bozardı.
 */
const HESAP_EKRANLARI: ReadonlySet<OgrenciHedefi> = new Set<HesapHedefi>([
  "hesap",
  "mesaj",
  "bildirim",
  "gorsel",
  "degisiklik",
  "talep",
  "onay",
  "kvkk",
  "guvenlik",
  "yardim",
  "canliIzleme",
]);
const ANALIZ_EKRANLARI: ReadonlySet<OgrenciHedefi> = new Set<AnalizHedefi>([
  "analiz",
  "konular",
  "hata",
]);
const ODUL_EKRANLARI: ReadonlySet<OgrenciHedefi> = new Set<OdulHedefi>([
  "oduller",
  "magaza",
  "cark",
  "liderlik",
  "davet",
  "siparislerim",
]);

export function Uygulama() {
  const sorgular = useQueryClient();
  const yeniApiGoruldu = useRef(false);
  const cevrimici = useBaglantiDurumu();
  const onbellekten = useOnbellektenGosteriliyor();
  const [ben, setBen] = useState<Ben | null>(null);
  const yalnizMentorum = yalnizMentorumMu(ben?.izinler ?? {});
  const mentorumMenusu = useMentorumMenusu(
    Boolean(
      ben?.girisYapildi &&
      ben.izinler?.["mentorum.icerik.kullan"] &&
      !(ben.onayKilidi?.kilitli && !ben.onayKilidiDevreDisi),
    ),
  );
  const onayKilitli = Boolean(
    ben?.girisYapildi && ben.onayKilidi?.kilitli && !ben.onayKilidiDevreDisi,
  );
  // Devam eden kuyruk partileri de her bekleme sonrasında bu kapıyı kontrol eder.
  const kullanimAcik = useRef(false);
  const yuzeySorgusu = useRef(0);
  const sahipKullanici = useRef<string | null>(null);
  const oturumNesli = useRef(oturum.nesil).current;
  const depo = useMemo(() => new IndexedDbDeposu(), []);
  const kuyruk = useMemo(
    () =>
      new SenkronKuyrugu(depo, kimlikUret, () =>
        oturum.nesil === oturumNesli ? sahipKullanici.current : null,
      ),
    [oturumNesli, depo],
  );

  const [girisDurumu, setGirisDurumu] = useState<"bilinmiyor" | "yok" | "var">("bilinmiyor");
  /*
    ================================================================
    HANGI YUZEY — SUNUCUDAN, ROLDEN TURETILMIYOR
    ================================================================
    Bu uygulama 05.09.2026'dan beri iki kisiye birden hizmet ediyor.
    `/auth/ben` iki AYRI bayrak donduruyor ve ikisi birden `true`
    olabiliyor (mezun ogrenci, kardesinin velisi). `null` = henuz
    sorulmadi ya da cevrimdisi acilis.
  */
  const [yuzey, setYuzey] = useState<{ ogrenciMi: boolean; veliMi: boolean } | null>(null);
  /* Ikisi birden olan kisi UST DUZEYDE gecis yapiyor; varsayilan ogrenci. */
  const [veliKipi, setVeliKipi] = useState(false);
  /*
    G-AUT-02a — girişte yedek kod harcandıysa kaç kod kaldığı.
    `null` = bu girişte yedek kod kullanılmadı; sunucu alanı yalnızca
    yedek kodla girildiğinde dolduruyor.
  */
  const [yedekKodUyarisi, setYedekKodUyarisi] = useState<number | null>(null);
  /* Giris ekranina NEDEN donuldugu — gerekce `giris-sebebi.ts`te. */
  const [girisSebebi, setGirisSebebi] = useState<GirisSebebi | null>(null);
  const [gorevler, setGorevler] = useState<Gorev[]>([]);
  /**
   * Görev listesi EN AZ BİR KEZ yüklenebildi mi.
   *
   * Bir kez `true` olunca `false`a dönmüyor: sonraki bir yenileme
   * düşse bile elimizdeki veri hâlâ gerçek ve gösterilmeye devam
   * ediyor. Ayrım "veri var mı" değil, "hiç ölçebildik mi".
   */
  const [gorevlerYuklendi, setGorevlerYuklendi] = useState(false);
  /*
    KENDI KAYDI SAKLANIYOR. Onceden `kendiKaydim()` yalnizca kimlik
    icin cagriliyor ve yanit ATILIYORDU; oysa ayni yanit ogrencinin
    ADINI da tasiyor (`api.ts` tipi darligi 04.09.2026'da duzeltildi).
    Kahramanin karsilamasi bunu istiyor.
  */
  const [kendim, setKendim] = useState<KendiOgrenciKaydi | null>(null);
  const [yukleniyor, setYukleniyor] = useState(false);
  const [hata, setHata] = useState<string | null>(null);
  const [senkronHatasi, setSenkronHatasi] = useState<string | null>(null);
  const [ozet, setOzet] = useState<Record<KuyrukDurumu, number>>(BOS_OZET);
  const [kip, setKip] = useState<Kip>({ tur: "yok" });
  const [hedef, setHedef] = useState<OgrenciHedefi>("bugun");
  /**
   * `Hesabim`i yeniden kuran sayaç — bir Hesabım ekranına her gidişte artıyor.
   *
   * `Hesabim` başlangıç ekranını `useState(baslangic ?? "menu")` ile YALNIZCA
   * ilk kurulumda okuyor. Zaten Hesabım'dayken zile ya da profil menüsüne
   * basıldığında bileşen sökülmüyor ve alt ekran olduğu gibi kalıyordu
   * (04.09.2026'da ölçüldü, C5). Sayaç `key` olarak veriliyor: her gidiş
   * "yeni bir Hesabım" demek.
   */
  const [hesapAnahtari, setHesapAnahtari] = useState(0);
  /*
    F-LIV-07 — CANLI IZLEME NOTU ICIN MODUL DURUMU, UYGULAMA DUZEYINDE BIR KEZ. Yalniz giris yapmis
    OGRENCI yuzeyinde soruluyor (veli kendi portalinda ayri soruyor); YALNIZ kesin kapali yanit notu gizler,
    hata/cevrimdisi notu gosterir (Emre 08.10: ogrenci bilsin).
    "Ayrinti" Hesabim'in bilgilendirme alt ekranini acar — zil dugmesiyle ayni yol (`hesapAnahtari`).
  */
  const canliAcik = useCanliModulAcik(
    !yalnizMentorum &&
      girisDurumu === "var" &&
      !onayKilitli &&
      !veliKipi &&
      yuzey?.ogrenciMi !== false,
  );
  /** Tek gezinti kapısı: Hesabım ekranına her gidiş alt ekranı yeniden kurar. */
  const git = useCallback((h: OgrenciHedefi) => {
    if (HESAP_EKRANLARI.has(h)) setHesapAnahtari((n) => n + 1);
    setHedef(h);
  }, []);
  const canliBilgiAc = useCallback(() => git("canliIzleme"), [git]);
  const canliBaglami = useMemo(
    () => ({ acik: canliAcik, bilgiAc: canliBilgiAc }),
    [canliAcik, canliBilgiAc],
  );
  const [denemeler, setDenemeler] = useState<DenemeOzeti[]>([]);
  const [denemeYukleniyor, setDenemeYukleniyor] = useState(false);
  const [kodlamaSonucu, setKodlamaSonucu] = useState<KodlamaSonucu | null>(null);
  const [kodlamaHatasi, setKodlamaHatasi] = useState<string | null>(null);
  const [gonderiliyor, setGonderiliyor] = useState(false);
  const [sayaclar, setSayaclar] = useState<Record<string, string>>({});
  /** Devralma istegi atilmis gorevler — ayni goreve tekrar tekrar istek atilmasin. */
  const devralinanlar = useRef<Set<string>>(new Set());
  /** Kuyrukta bekleyen görev kimlikleri — kartta "gönderilecek" rozeti için */
  const [bekleyenGorevler, setBekleyenGorevler] = useState<Set<string>>(new Set());
  // F-STV-04a — haftalik ekrandaki gecmis gun listesi kayit gonderilince yeniden okunur.
  const [haftaYenile, setHaftaYenile] = useState(0);
  const [pwa, setPwa] = useState<PwaDurumu>({ guncellemeHazir: false, cevrimdisiHazir: false });

  useEffect(() => pwaDinle(setPwa), []);

  const ozetiYenile = useCallback(async () => {
    if (!kullanimAcik.current) return;
    try {
      setOzet(await kuyruk.ozet());
      const bekleyen = await kuyruk.gonderilecekler();
      setBekleyenGorevler(
        new Set(
          bekleyen.map((k) => k.govde.gorevId).filter((x): x is string => typeof x === "string"),
        ),
      );
    } catch (hata) {
      setSenkronHatasi(
        hata instanceof Error ? hata.message : "Kayıt deponuz açılamadı. Lütfen yeniden deneyiniz.",
      );
    }
  }, [kuyruk]);

  // --- Oturum ---
  /**
   * YÜZEYİ SUNUCUYA SORAR — açılışta VE her girişten sonra.
   *
   * ================================================================
   * ÖLÇÜLDÜ 07.09.2026: GİRİŞTEN SONRA SORULMUYORDU
   * ================================================================
   * Bu blok yalnızca `useEffect(..., [])` içindeydi, yani sekme
   * AÇILDIĞINDA bir kez. Girişten sonra `girisDurumu` "var"a
   * çekiliyor ama `yuzey` ve `veliKipi` ÖNCEKİ kullanıcıdan kalıyordu.
   *
   * Canlı sonuç: öğrenci çıkış yaptı, aynı sekmede veli giriş yaptı
   * ve VELİ ÖĞRENCİ KABUĞUNA DÜŞTÜ — çocuk portalı hiç açılmadı,
   * ekranda *"Bu hesap bir öğrenci hesabı değil"* yazdı ve tek çözüm
   * sayfayı yenilemekti.
   *
   * Tam da bu uygulamanın hedef senaryosu: EVDE PAYLAŞILAN TELEFON.
   * Veli, çocuğunun telefonundan kendi hesabına giriyor.
   *
   * Hata bugüne kadar görünmedi çünkü bir oturumda tek kullanıcı
   * denenmişti. F-NTF-09 doğrulaması iki hesabı arka arkaya açınca
   * ortaya çıktı.
   */
  const yuzeyiSor = useCallback(
    async (taze = false) => {
      const sorgu = ++yuzeySorgusu.current;
      try {
        const ben = onayBilgisi.benYanitiniIsle(await benGetir(taze), false);
        if (sorgu !== yuzeySorgusu.current) return;
        if (ben.onayKilidi !== undefined && !yeniApiGoruldu.current) {
          yeniApiGoruldu.current = true;
          void sorgular.invalidateQueries({ queryKey: ["veli-cocuklarim"] });
        }
        kullanimAcik.current =
          ben.girisYapildi && !(ben.onayKilidi?.kilitli && !ben.onayKilidiDevreDisi);
        setBen(ben);
        if (yalnizMentorumMu(ben.izinler ?? {})) setHedef("mentorum");
        sahipKullanici.current = ben.girisYapildi ? ben.userId : null;
        setGirisDurumu(ben.girisYapildi ? "var" : "yok");
        if (ben.girisYapildi) {
          setYuzey({ ogrenciMi: ben.ogrenciMi, veliMi: ben.veliMi });
          /*
          YALNIZCA VELI olan kisi ogrenci ekranini hic gormemeli:
          varsayilan kip ogrenci oldugu icin burada ayarlaniyor.
          Ikisi birden olan kisi ogrenci kipinde basliyor ve gecisi
          kendi yapiyor — o yuzden ATAMA kosulsuz: onceki
          kullanicidan kalan "veli kipi" bir sonraki girise
          tasinmamali.
        */
          setVeliKipi(ben.veliMi && !ben.ogrenciMi);
        }
      } catch {
        if (sorgu !== yuzeySorgusu.current) return;
        kullanimAcik.current = false;
        // Bilinen kilitte ağ hatası haklar ekranını giriş formuyla değiştirmez.
        setGirisDurumu(onayBilgisi.kilitli(sahipKullanici.current) ? "var" : "yok");
      }
    },
    [sorgular],
  );

  const onayiYenile = useCallback(() => yuzeyiSor(true), [yuzeyiSor]);

  useEffect(() => {
    void yuzeyiSor();
    const dogrula = () => {
      void yuzeyiSor();
    };
    const onayDogrula = () => {
      kullanimAcik.current = false;
      onayBilgisi.kilitle(sahipKullanici.current);
      setBen((eski) => (eski ? onayBilgisi.benYanitiniIsle(eski, false) : eski));
      // Bilinen 403, çevrimdışı önbellekteki eski "kilitsiz" cevapla açılamaz.
      void onayiYenile();
    };
    window.addEventListener("onay-kilidi", onayDogrula);
    window.addEventListener("focus", dogrula);
    window.addEventListener("online", dogrula);
    return () => {
      window.removeEventListener("onay-kilidi", onayDogrula);
      window.removeEventListener("focus", dogrula);
      window.removeEventListener("online", dogrula);
    };
  }, [yuzeyiSor, onayiYenile]);

  // --- Gorevler ---
  const gorevleriYukle = useCallback(async () => {
    if (!kullanimAcik.current || yalnizMentorum) return;
    setYukleniyor(true);
    setHata(null);
    try {
      const kayit = await kendiKaydim();
      if (!kullanimAcik.current) return;
      setKendim(kayit);
      setGorevler(await bugunkuGorevler(kayit.id));
      setGorevlerYuklendi(true);
    } catch (err) {
      if (err instanceof AgHatasi) {
        setHata("Bağlantı yok. Girdiğin veriler telefonunda bekliyor, bağlanınca gönderilecek.");
      } else if (err instanceof ApiHatasi && err.oturumBittiMi) {
        setGirisSebebi("oturum");
        setGirisDurumu("yok");
      } else if (err instanceof ApiHatasi && err.kod === "OGRENCI_DEGIL") {
        setHata("Bu hesap bir öğrenci hesabı değil. Personel paneli ayrı adreste.");
      } else if (err instanceof ApiHatasi && err.sunucuArizasiMi) {
        // 5xx'te sunucunun cümlesi ("Sunucu 500 döndü.") öğrenciye bir şey
        // anlatmıyor; ne olduğunu söyleyip kimliği destek için bırakıyoruz.
        // Ne yapacağı ("Tekrar dene") ekranda düğme olarak duruyor.
        setHata(
          `Görevlerin şu anda alınamadı.${err.istekId ? ` Sorun sürerse bu kimliği ilet: ${err.istekId}` : ""}`,
        );
      } else {
        setHata(hataMetni(err, "Görevler alınamadı."));
      }
    } finally {
      setYukleniyor(false);
    }
  }, [yalnizMentorum]);

  /**
   * Denemeler AYRI yukleniyor ve yalnizca sekme acilinca: gunluk
   * gorev ekranini acan her ogrenci icin fazladan bir istek yapmak,
   * en cok kullanilan ekrani en yavas ekran yapardi.
   */
  const denemeleriYukle = useCallback(async () => {
    if (!kullanimAcik.current) return;
    setDenemeYukleniyor(true);
    try {
      setDenemeler(await denemelerim());
    } catch (err) {
      if (err instanceof ApiHatasi && err.oturumBittiMi) {
        setGirisSebebi("oturum");
        setGirisDurumu("yok");
      } else setHata(hataMetni(err, "Denemeler alınamadı."));
    } finally {
      setDenemeYukleniyor(false);
    }
  }, []);

  useEffect(() => {
    /*
      VELI KIPINDE OGRENCI VERISI HIC ISTENMIYOR.

      `kendiKaydim()` yalnizca veli olan kisi icin `OGRENCI_DEGIL`
      donuyor; istegi atip hatayi yutmak, her acilista gereksiz bir
      403 uretmek ve ekrana "bu hesap bir ogrenci hesabi degil" gibi
      YANLIS bir cumle dusurme riski demekti.
    */
    if (girisDurumu === "var" && !onayKilitli && !veliKipi) {
      void gorevleriYukle();
      void ozetiYenile();
    }
  }, [girisDurumu, onayKilitli, veliKipi, gorevleriYukle, ozetiYenile]);

  useEffect(() => {
    if (girisDurumu === "var" && !onayKilitli && !veliKipi && hedef === "denemeler")
      void denemeleriYukle();
  }, [girisDurumu, onayKilitli, veliKipi, hedef, denemeleriYukle]);

  /**
   * OKUNMAMIŞ MESAJ SAYACI — F-MSG
   *
   * ================================================================
   * NEDEN AYRI BİR SORGU
   * ================================================================
   * Mesajlar `Hesabım`ın içinde (altıncı sekme açılmadı: 390px'te altı
   * girdi 65px'e düşüyor). Gömülü bir gelen kutusu, SAYAÇSIZ, sessiz
   * bir kutu olurdu — öğrenci ancak rastgele bakarsa görürdü.
   *
   * Sayaç `Mesajlar` ekranından bağımsız çalışmak ZORUNDA: o ekran
   * açılmadan sayının bilinmesi gerekiyor, zaten sebebi bu.
   *
   * Aralık 60 sn: bu modülde anlık teslim YOK (WebSocket yazılmadı ve
   * "çevrimiçi" göstergesi bir gözetim yüzeyi). Hata YUTULUYOR —
   * sayaç bir kolaylık; düşen bir istek yüzünden ekrana hata basmak,
   * öğrenciyi ilgisiz bir arızayla karşılardı.
   */
  const [okunmamisMesaj, setOkunmamisMesaj] = useState(0);
  const mesajSay = useCallback(async () => {
    if (!kullanimAcik.current) return;
    try {
      const kutu = await mesajKutum();
      setOkunmamisMesaj(kutu.toplamOkunmamis);
    } catch {
      // sessiz — yukarıdaki nota bakın
    }
  }, []);
  useEffect(() => {
    if (girisDurumu !== "var" || onayKilitli || yalnizMentorum) return;
    void mesajSay();
    const t = setInterval(() => void mesajSay(), 60_000);
    return () => clearInterval(t);
  }, [girisDurumu, onayKilitli, yalnizMentorum, mesajSay]);

  /**
   * OKUNMAMIŞ BİLDİRİM SAYACI — F-NTF-09
   *
   * ================================================================
   * MESAJ SAYACIYLA AYNI DESEN, AYRI SORGU
   * ================================================================
   * Tek bir uçta birleştirmek daha az istek demek olurdu ama iki ayrı
   * modülün sayısını tek yanıta bağlamak, birinin düşmesini ötekinin
   * de suskunluğuna çevirirdi. İkisi de hatayı YUTUYOR: sayaç bir
   * kolaylık ve düşen bir istek yüzünden ekrana hata basmak, öğrenciyi
   * ilgisiz bir arızayla karşılardı.
   *
   * Aralık yine 60 sn. Bildirim "hemen görülmesi gereken" bir şey
   * değil (o kanal e-posta/SMS ve henüz açık değil), ama beş dakika
   * beklemek rozeti anlamsız kılardı.
   */
  const [okunmamisBildirim, setOkunmamisBildirim] = useState(0);
  const bildirimSay = useCallback(async () => {
    if (!kullanimAcik.current) return;
    try {
      const sayac = await bildirimSayaci();
      setOkunmamisBildirim(sayac.okunmamis);
    } catch {
      // sessiz — yukarıdaki nota bakın
    }
  }, []);
  useEffect(() => {
    if (girisDurumu !== "var" || onayKilitli || yalnizMentorum) return;
    void bildirimSay();
    const t = setInterval(() => void bildirimSay(), 60_000);
    return () => clearInterval(t);
  }, [girisDurumu, onayKilitli, yalnizMentorum, bildirimSay]);

  /**
   * Deneme cevaplarini gonderir.
   *
   * ================================================================
   * KUYRUGA ALINMIYOR — GOREV VERISINDEN FARKLI
   * ================================================================
   * Gorev verisi cevrimdisi kuyruga giriyor cunku ogrenci gun icinde
   * her an giriyor ve baglanti kopabilir. Deneme cevaplari PENCEREYE
   * bagli: kuyrukta bekleyen bir gonderim pencere kapandiktan sonra
   * ulasirsa sunucu onu reddeder ve ogrenci cevaplarinin gittigini
   * sanirdi. Burada basarisizlik GORUNUR olmali.
   */
  const denemeGonder = useCallback(
    async (deneme: DenemeOzeti, cevaplar: Record<string, string>, sure: number | null) => {
      setGonderiliyor(true);
      setKodlamaHatasi(null);
      try {
        setKodlamaSonucu(await denemeKodla(deneme.id, cevaplar, sure));
        void denemeleriYukle();
      } catch (err) {
        if (err instanceof AgHatasi) {
          setKodlamaHatasi("Bağlantı yok. Cevapların GÖNDERİLMEDİ — bağlanınca tekrar dene.");
        } else if (err instanceof ApiHatasi) {
          setKodlamaHatasi(err.message);
        } else {
          setKodlamaHatasi("Cevaplar gönderilemedi.");
        }
      } finally {
        setGonderiliyor(false);
      }
    },
    [denemeleriYukle],
  );

  // --- Kuyrugu gonder ---
  const gonderici = useMemo(
    () =>
      new KuyrukGondericisi(
        kuyruk,
        (sahip, kayitlar) =>
          senkronGonder(
            sahip,
            kayitlar.map(({ istemciKayitId, islem, govde, yapildiAt }) => ({
              istemciKayitId,
              islem,
              govde,
              yapildiAt,
            })),
          ),
        () =>
          kullanimAcik.current && oturum.nesil === oturumNesli && sahipKullanici.current !== null,
        undefined,
        gorevleriYukle,
        (gecerli) => karantinayiKurtar(depo, gecerli),
      ),
    [kuyruk, oturumNesli, gorevleriYukle, depo],
  );
  const kuyruguGonder = useCallback(async () => {
    if (!kullanimAcik.current || !cevrimici || !sahipKullanici.current) return;
    try {
      await gonderici.gonderimiDene();
      if (oturum.nesil !== oturumNesli) return;
      setSenkronHatasi(null);
      await ozetiYenile();
    } catch (hata) {
      if (oturum.nesil === oturumNesli)
        setSenkronHatasi(
          hata instanceof Error
            ? hata.message
            : "Kayıtlarınız eşitlenemedi. Cihazınızda korunuyor.",
        );
    }
  }, [cevrimici, gonderici, ozetiYenile, oturumNesli]);

  // Baglanti gelince ve duzenli araliklarla dene.
  useEffect(() => {
    if (girisDurumu !== "var" || onayKilitli) return;
    void kuyruguGonder();
    const zamanlayici = setInterval(() => void kuyruguGonder(), SENKRON_ARALIGI);
    return () => clearInterval(zamanlayici);
  }, [girisDurumu, onayKilitli, cevrimici, kuyruguGonder]);

  // --- Islemler ---
  async function veriKaydet(gorev: Gorev, veri: VeriGirdisi): Promise<void> {
    // IYIMSER GUNCELLEME: kart hemen degisiyor, kayit kuyruga giriyor.
    // Sunucuyu beklemek, cevrimdisi ogrenciyi bekleten bir ekran olurdu.
    await kuyruk.ekle("gorev.sonuc.gir", { gorevId: gorev.id, ...veri });
    setGorevler((g) =>
      g.map((x) =>
        x.id === gorev.id
          ? {
              ...x,
              correctCount: veri.correctCount,
              wrongCount: veri.wrongCount,
              emptyCount: veri.emptyCount,
              durationSeconds: veri.durationSeconds,
              // Durum TAHMINI — sunucu kesin durumu doner ve uzerine yazilir.
              gosterilecekDurum: veri.tamamlandi ? "COMPLETED" : "PARTIAL",
            }
          : x,
      ),
    );
    setKip({ tur: "yok" });
    await ozetiYenile();
    void kuyruguGonder().then(() => setHaftaYenile((n) => n + 1));
  }

  async function mazeretGonder(gorev: Gorev, neden: string, not: string | null): Promise<void> {
    await kuyruk.ekle("gorev.mazeret.bildir", { gorevId: gorev.id, neden, not });
    setGorevler((g) =>
      g.map((x) => (x.id === gorev.id ? { ...x, gosterilecekDurum: "FAILED" } : x)),
    );
    setKip({ tur: "yok" });
    await ozetiYenile();
    void kuyruguGonder().then(() => setHaftaYenile((n) => n + 1));
  }

  /**
   * Calisma sayaci.
   *
   * ================================================================
   * SAYAC CEVRIMDISI CALISMIYOR — BILEREK
   * ================================================================
   * Sayac sunucuda oturum aciyor (`StudyTimerSession`) cunku terk
   * edilmis oturumlari tespit eden kalp atisi mantigi orada. Cevrimdisi
   * baslatilip sunucuya hic ulasmayan bir sayac, ogrencinin "calistim
   * ama kaydolmadi" demesine yol acardi.
   *
   * Cevrimdisi kalan ogrenci sureyi ELLE giriyor (veri giris ekranindaki
   * dakika alani) ve o kayit kuyruga giriyor.
   */
  /*
    ================================================================
    KALP ATIŞI — SAYAÇ AÇIKKEN F-STV-06
    ================================================================
    Sunucu, kalp atışı `TIMER_TERK_ESIGI_DAKIKA` (120 dk) değerinden
    eskiyse oturumu TERK EDİLMİŞ sayıyor ve süreyi **son kalp atışına
    kadar** yazıyor.

    Atış hiç gönderilmezse `lastHeartbeat` başlangıç anında kalıyor.
    Yani gerçekten iki saatten uzun tek oturum çalışan öğrencinin
    süresi sıfır saniye yazılıyordu — sayacı açık tutmasının cezası
    çalışmasının hiç sayılmaması oluyordu.

    SEKME GÖRÜNÜR OLUNCA EK ATIŞ GÖNDERİLMİYOR ve bu bilinçli: telefon
    cebe girince tarayıcı sayfayı donduruyor, dönüşte atmak "cepte
    geçen üç saat" çalışma sayılırdı. Eksik saymak, fazla saymaktan
    iyidir — süre öğrencinin karnesine giriyor.
  */
  /*
    ================================================================
    SUNUCUDA ACIK KALAN SAYAC DEVRALINIYOR — F-STV-06
    ================================================================
    `sayaclar` React durumu; sayfa yenilenince (PWA'da sik) BOSALIYOR.
    Sunucudaki oturum ise duruyor ve gorev listesi `timerCalisiyor:
    true` donuyor. 04.09.2026'da olculen iki sonuc:

    1) KALP ATISI HIC GITMIYORDU. Asagidaki aralik `sayaclar`
       uzerinde donuyor; bos oldugu icin tek atis atilmiyor,
       `lastHeartbeat` baslangic aninda kaliyor. Iki saati asan her
       oturum `gorev-giris.ts` -> `timerSuresi` tarafindan TERK
       EDILMIS sayilip suresi son atisa — yani BASLANGICA — kadar
       yaziliyor: SIFIR saniye. Uzun calismanin cezasi calismanin hic
       sayilmamasi oluyordu. Dosyanin kendi notu bu tuzagi zaten
       anlatiyor; yenileme kapisindan geri girmisti.

    2) "BITIR" DUGMESI BASLATIYORDU. Kart `timerCalisiyor` ile
       "Bitir" yaziyor ama `sayacDegistir` yerel haritaya bakip
       `sayacBaslat` cagiriyordu. Sunucu ACIK OTURUMU geri donuyor
       (`zatenAcikti: true`), yani hicbir sey olmuyor ve ogrenci
       sayacini durdurdugunu saniyordu.

    `sayacBaslat` bilerek etkisiz-tekrarlanabilir: acik oturum varsa
    yenisini ACMIYOR, mevcudu doner. Devralmak icin dogru cagri o.
    `devralinanlar` ayni gorev icin tekrar tekrar istek atmayi
    engelliyor; istek duserse kaydi silinip yeniden denenebiliyor.
  */
  useEffect(() => {
    if (onayKilitli || !kullanimAcik.current) return;
    const yeni = gorevler.filter((g) => g.timerCalisiyor && !devralinanlar.current.has(g.id));
    if (yeni.length === 0) return;
    for (const g of yeni) devralinanlar.current.add(g.id);

    void (async () => {
      for (const g of yeni) {
        if (!kullanimAcik.current) return;
        try {
          const oturum = await sayacBaslat(g.id);
          setSayaclar((s) => (s[g.id] ? s : { ...s, [g.id]: oturum.id }));
        } catch {
          // Devralinamadi; bir sonraki listede tekrar denensin.
          devralinanlar.current.delete(g.id);
        }
      }
    })();
  }, [gorevler, onayKilitli]);

  useEffect(() => {
    if (onayKilitli || !kullanimAcik.current) return;
    const oturumlar = Object.values(sayaclar);
    if (oturumlar.length === 0) return;

    const zamanlayici = setInterval(() => {
      for (const oturumId of oturumlar) {
        if (!kullanimAcik.current) return;
        /*
          Hata YUTULUYOR. Kalp atisi kullanicinin baslattigi bir is
          degil; basarisiz olunca ekrana hata basmak, calisirken
          telefonu sinyalsiz kalan ogrenciye anlamadigi bir uyari
          gostermek olurdu. Kayip atisin bedeli zaten sinirli: sure
          bir onceki atisa kadar yaziliyor.
        */
        void sayacKalp(oturumId).catch(() => undefined);
      }
    }, KALP_ARALIGI_MS);

    return () => clearInterval(zamanlayici);
  }, [sayaclar, onayKilitli]);

  async function sayacDegistir(gorev: Gorev): Promise<void> {
    const acik = sayaclar[gorev.id];
    try {
      if (acik) {
        await sayacBitir(acik);
        setSayaclar((s) => {
          const y = { ...s };
          delete y[gorev.id];
          return y;
        });
        // Devralma kaydi da dusuyor: ogrenci ayni gorevin sayacini
        // tekrar baslatirsa yenileme sonrasi yine devralinabilmeli.
        devralinanlar.current.delete(gorev.id);
        await gorevleriYukle();
      } else {
        const oturum = await sayacBaslat(gorev.id);
        setSayaclar((s) => ({ ...s, [gorev.id]: oturum.id }));
        setGorevler((g) =>
          g.map((x) => (x.id === gorev.id ? { ...x, gosterilecekDurum: "STARTED" } : x)),
        );
      }
    } catch (err) {
      setHata(
        err instanceof AgHatasi
          ? "Sayaç için bağlantı gerekiyor. Bağlantın yokken süreyi elle girebilirsin."
          : err instanceof Error
            ? err.message
            : "Sayaç çalıştırılamadı.",
      );
    }
  }

  // --- Ekranlar ---
  if (girisDurumu === "bilinmiyor") {
    return <Iskelet satir={4} />;
  }

  if (girisDurumu === "yok") {
    return (
      <Giris
        sebep={girisSebebi}
        onGirdi={(kalanYedekKod) => {
          setYedekKodUyarisi(kalanYedekKod);
          setGirisSebebi(null);
          // F-AUTH-07 — hesap doğrulanana kadar eski kullanıcı ekranı açılmaz.
          setGirisDurumu("bilinmiyor");
          void yuzeyiSor();
        }}
      />
    );
  }

  const bant = yedekKodBandi(yedekKodUyarisi);

  /** Çıkış Hesabım menüsünden, onay kilidinden ve veli kabuğundan çağrılıyor. */
  const cikisIslemi = (): void => {
    void cikisYap()
      .catch(() => undefined)
      // Cevrimdisi okuma onbellegi de dusuyor: ayni telefondan giren
      // IKINCI ogrenci, agi yokken birincinin programini okuyabilirdi.
      // Gerekce `pwa-onbellek.ts` icinde.
      .then(() => okumaOnbellegiTemizle())
      .finally(() => {
        setGirisSebebi("cikis");
        setGirisDurumu("yok");
      });
  };

  if (onayKilitli && ben) {
    return (
      <>
        {pwa.guncellemeHazir && (
          <div role="status" className="p-4">
            Yeni sürüm hazır. <Buton onClick={() => void pwaGuncelle()}>Uygulamayı güncelle</Buton>
          </div>
        )}
        <OnayKilidi ben={ben} yenile={onayiYenile} onCikis={cikisIslemi} />
      </>
    );
  }

  const bekleyenSayisi = ozet.bekliyor + ozet.gonderiliyor;
  /*
    Kahramanin sayilari SAF MODULDEN geliyor (`gunluk-ozet.ts`).
    Burada durduklari surece test edilemiyorlardi ve F-SCH-09'u
    ihlal ettikleri alti gun gorulmedi — gerekce o dosyada yazili.
  */
  const ozetSayilari = gunlukOzet(gorevler);

  /*
    ================================================================
    KIP GECISI YALNIZCA IKISI BIRDEN OLAN KISIYE
    ================================================================
    `yuzey` `null` ise (cevrimdisi acilis: `/auth/ben` sorulamadi)
    gecis CIZILMIYOR — bilinmeyen bir durumda secim sunmak, olmayan
    bir secim sunmaktir. O halde varsayilan ogrenci kipi kaliyor ve
    onbellekten okunan program calismaya devam ediyor.

    Tek kipi olan kisiye de cizilmiyor: veli olmayan ogrenciye
    "Cocugum" dugmesi gostermek, basildiginda bos bir ekran acardi.
  */
  const gecisVar = yuzey?.ogrenciMi === true && yuzey.veliMi === true;

  if (veliKipi) {
    return (
      <VeliKabugu
        gecisVar={gecisVar}
        onOgrenciyeGec={() => setVeliKipi(false)}
        onCikis={cikisIslemi}
        /*
          `bant` KİPTEN ÖNCE hesaplanıyor ve buraya da veriliyor:
          yedek kodla giren kişi öğrenci de olabilir veli de, sunucu
          ikisini de aynı uçtan geçiriyor. Yalnızca öğrenci kabuğuna
          vermek, velinin kilitlenmesini sessizleştiriyordu.
        */
        yedekKodBant={bant}
        onYedekKodKapat={() => setYedekKodUyarisi(null)}
      />
    );
  }

  /*
    HESABIM BAŞLANGICI hedeften: menüden "hesap" seçildiyse liste, alt ekran
    seçildiyse doğrudan o ekran. `undefined` = menü.
  */
  const hesapBaslangic = hedef === "hesap" ? undefined : (hedef as Exclude<HesapHedefi, "hesap">);
  const tamAd = kendim ? [kendim.ad, kendim.soyad].filter(Boolean).join(" ") || null : null;

  return (
    <OgrenciKabugu
      aktif={yalnizMentorum ? "mentorum" : hedef}
      onSec={git}
      mentorumAcik={mentorumMenusu === "acik"}
      yalnizMentorum={yalnizMentorum}
      /*
        ROZETLER AYRI — F-MSG + F-NTF-09. 9b'ye kadar şeritteki "Hesabım" rozeti
        ikisinin TOPLAMINI gösteriyordu ve hangi kutunun dolu olduğu
        söylenmiyordu. Artık balon mesajı, zil bildirimi sayıyor.
      */
      okunmamis={{ mesaj: okunmamisMesaj, bildirim: okunmamisBildirim }}
      ad={tamAd}
      canliAcik={canliAcik === true}
      /*
        ÖĞRENCİ KİPİNDEYKEN "Çocuğum"A GEÇİŞ — yalnızca ikisi birden olan kişiye
        (gerekçe `VeliKabugu.tsx`). Profil menüsünde; 9b'ye kadar her ekranın
        tepesinde tam genişlik bir düğmeydi.
      */
      onVeliyeGec={gecisVar ? () => setVeliKipi(true) : undefined}
      onCikis={cikisIslemi}
      ustBilgi={
        <>
          <BaglantiSeridi
            cevrimici={cevrimici}
            onbellekten={onbellekten}
            bekleyen={bekleyenSayisi}
            hatali={ozet.hatali}
            hata={senkronHatasi}
          />
          {/*
            Guncelleme HAZIR ama uygulanmadi. Kendiliginden yenilemek,
            ogrenci veri girerken yazdigini kaybettirirdi — karar onun.
          */}
          {pwa.guncellemeHazir && (
            <div className="rounded-alan bg-marka-50 text-marka-700 mt-2 flex items-center gap-2 px-3 py-2 text-xs">
              <span className="flex-1">Yeni sürüm hazır.</span>
              <Buton gorunum="ikincil" onClick={() => void pwaGuncelle()}>
                Yenile
              </Buton>
            </div>
          )}
        </>
      }
    >
      {/*
        YEDEK KOD BANDI — G-AUT-02a, BÖLÜMDEN BAĞIMSIZ. Öğrenci girişten sonra
        hangi ekranda olursa olsun bu bandı görmeli; sayı, kodun harcandığı anda
        söylenmezse söylenecek başka bir an yok. Çizim `YedekKodBandi`de (veli de
        aynı bandı görüyor).
      */}
      <YedekKodBandi bant={bant} onKapat={() => setYedekKodUyarisi(null)} />

      {yalnizMentorum || hedef === "mentorum" ? (
        mentorumMenusu === "bekliyor" ? (
          <Iskelet satir={3} />
        ) : mentorumMenusu === "acik" ? (
          <Mentorum />
        ) : mentorumMenusu === "hata" ? (
          <BosDurum
            baslik="Mentörüm durumu alınamadı"
            aciklama="Bağlantını kontrol edip sayfayı yenileyebilirsin."
          />
        ) : (
          <BosDurum baslik="Şu anda kullanılabilir bölüm yok" />
        )
      ) : ANALIZ_EKRANLARI.has(hedef) ? (
        <Gelisim gorunum={hedef as AnalizHedefi} onGorunum={git} />
      ) : ODUL_EKRANLARI.has(hedef) ? (
        <div className="flex flex-1 flex-col p-4 lg:px-4 lg:py-2">
          <Oduller gorunum={hedef as OdulHedefi} onGorunum={git} />
        </div>
      ) : HESAP_EKRANLARI.has(hedef) ? (
        /*
          ROZET OKUNUNCA HEMEN DÜŞÜYOR — 60 sn beklemiyor (06.09.2026 canlı
          ölçüm: rozet okunduktan sonra bir dakika daha duruyordu).
          F-LIV-07 — "Canlı çalışma izleme" satırı modül durumunu bağlamdan okuyor.
        */
        <CanliIzlemeBaglami value={canliBaglami}>
          <Hesabim
            key={hesapAnahtari}
            baslangic={hesapBaslangic}
            onMesajOkundu={() => void mesajSay()}
            onBildirimOkundu={() => void bildirimSay()}
            onCikis={cikisIslemi}
          />
        </CanliIzlemeBaglami>
      ) : hedef === "takvim" ? (
        /*
          TAKVİM profil menüsünde (9b). 9b'ye kadar Program'ın ikinci görünümüydü;
          Program artık UNİKOÇ'un haftalık görünümünün birebiri ve tek görünüm.
          Takvim (görüşme, deneme, ICS aboneliği) kaybolmadı: profil menüsünde ve
          masaüstü yan menüsünde Program'ın altında.
        */
        <div className="flex flex-1 flex-col pt-4 lg:pt-2">
          <div className="px-4">
            <SayfaBasligi
              baslik="Takvimim"
              aciklama="Görüşmelerin, denemelerin ve etkinliklerin — telefonunun takvimine de ekleyebilirsin."
              ikon="takvim"
            />
          </div>
          <Takvimim />
        </div>
      ) : hedef === "program" ? (
        <div className="flex flex-1 flex-col gap-3 p-4 lg:px-4 lg:py-2">
          {/*
            PROGRAM — UNİKOÇ öğrenci görünümü (HaftalikProgram.tsx). Sayfanın h1'i
            başlık kartında (öğrencinin adı + "Haftalık Program" hapı).
          */}
          {kendim ? (
            <HaftalikProgram
              ogrenciId={kendim.id}
              ad={tamAd}
              gecmisGunGirisi={{
                onVeriGir: (g) => setKip({ tur: "veri", gorev: g }),
                onYapamadim: (g) => setKip({ tur: "mazeret", gorev: g }),
                bekleyen: bekleyenGorevler,
                yenile: haftaYenile,
              }}
              onRevizyon={() => git("degisiklik")}
            />
          ) : (
            <Iskelet satir={4} />
          )}
        </div>
      ) : hedef === "denemeler" ? (
        <div className="flex flex-1 flex-col gap-4 p-4 lg:px-4 lg:py-2">
          <SayfaBasligi
            baslik="Deneme Sınavları"
            aciklama="Sana atanan denemeler, cevap girişi ve net gelişimin."
            ikon="deneme"
          />
          {/* Dalga 3 — tür bazlı net gelişimi (SELF); sonuç yoksa hiçbir şey çizmiyor. */}
          {kendim && <DenemeNetlerim ogrenciId={kendim.id} />}
          {kendim && <Karne key={kendim.id} ogrenciId={kendim.id} istek={api} />}
          {denemeYukleniyor && denemeler.length === 0 ? (
            <Iskelet satir={4} />
          ) : (
            <DenemeListesi
              denemeler={denemeler}
              yukleniyor={denemeYukleniyor}
              onYenile={() => void denemeleriYukle()}
              onKodla={(d) => {
                setKodlamaSonucu(null);
                setKodlamaHatasi(null);
                setKip({ tur: "deneme", deneme: d });
              }}
            />
          )}
        </div>
      ) : (
        <div className="flex flex-1 flex-col gap-4 p-4 lg:px-4 lg:py-2">
          {/*
            KAHRAMAN — F-STV-10 ilerlemesi halkanın kendisi. 9b: kenardan kenara
            blok yerine yuvarlak degrade kart (UNİKOÇ kart dili); h1 bu kartta.
          */}
          <BugunKahramani
            ad={kendim?.ad ?? null}
            tamamlanan={ozetSayilari.tamamlanan}
            toplam={ozetSayilari.toplam}
            cozulenSoru={ozetSayilari.cozulenSoru}
            hedefSoru={ozetSayilari.hedefSoru}
            mazeretli={ozetSayilari.mazeretli}
            veriGeldi={gorevlerYuklendi}
          />

          {/*
            `uyari-800`: şerit SAYFA ZEMİNİNDE duruyor; `uyari-600` tuval üzerinde
            4,32'ye düşüyordu (05.09.2026 canlı ölçüm). TEKRAR DENE hatanın yanında
            (UI/UX Dalga 1, Ö10/F10).
          */}
          {hata && (
            <div
              role="alert"
              className="rounded-alan bg-uyari-500/15 text-uyari-800 flex flex-wrap items-center gap-x-3 gap-y-2 px-3 py-2 text-sm"
            >
              <span className="min-w-0 flex-1">{hata}</span>
              <Buton
                gorunum="ikincil"
                yukleniyor={yukleniyor}
                onClick={() => void gorevleriYukle()}
              >
                Tekrar dene
              </Buton>
            </div>
          )}

          {/* F-NTF-08b — koç duyurusu; duyuru yoksa hiç çizilmez */}
          <Duyurularim />

          {gorevler.length > 0 && (
            <h2 className="text-metin-koyu text-lg font-bold">Bugünün görevleri</h2>
          )}

          {yukleniyor && gorevler.length === 0 && <Iskelet satir={4} />}

          {!yukleniyor && gorevler.length === 0 && !hata && (
            <BosDurum
              baslik="Bugün için görev yok"
              aciklama="Koçun bu haftanın programını yayınlayınca görevlerin burada görünecek."
              eylem={
                <Buton gorunum="ikincil" onClick={() => void gorevleriYukle()}>
                  Yenile
                </Buton>
              }
            />
          )}

          <CanliIzlemeBaglami value={canliBaglami}>
            <div className="grid gap-3 lg:grid-cols-2">
              {gorevler.map((g) => (
                <GorevKarti
                  key={g.id}
                  gorev={g}
                  sayacCalisiyor={Boolean(sayaclar[g.id]) || g.timerCalisiyor}
                  bekleyenSenkron={bekleyenGorevler.has(g.id)}
                  onVeriGir={() => setKip({ tur: "veri", gorev: g })}
                  onYapamadim={() => setKip({ tur: "mazeret", gorev: g })}
                  onSayac={() => void sayacDegistir(g)}
                />
              ))}
            </div>
          </CanliIzlemeBaglami>
        </div>
      )}

      {kip.tur === "deneme" && (
        <div className="bg-notr-0 fixed inset-0 z-40 overflow-y-auto p-4">
          <KodlamaAc
            key={kip.deneme.atamaId}
            deneme={kip.deneme}
            gonderiliyor={gonderiliyor}
            hata={kodlamaHatasi}
            sonuc={kodlamaSonucu}
            onGonder={(cevaplar, sure) => void denemeGonder(kip.deneme, cevaplar, sure)}
            onKapat={() => {
              setKip({ tur: "yok" });
              setKodlamaSonucu(null);
              setKodlamaHatasi(null);
            }}
          />
        </div>
      )}

      {kip.tur === "veri" && (
        <VeriGirisi
          gorev={kip.gorev}
          onKapat={() => setKip({ tur: "yok" })}
          onKaydet={(v) => void veriKaydet(kip.gorev, v)}
        />
      )}

      {kip.tur === "mazeret" && (
        <Yapamadim
          gorev={kip.gorev}
          onKapat={() => setKip({ tur: "yok" })}
          onGonder={(neden, not) => void mazeretGonder(kip.gorev, neden, not)}
        />
      )}
    </OgrenciKabugu>
  );
}

/**
 * Baglanti ve kuyruk seridi.
 *
 * Cevrimdisi olmak BIR HATA DEGIL — sistemin verdigi soz zaten "girdigin
 * veri telefonunda bekler, baglanti gelince gonderilir". Bu yuzden serit
 * notr renkte; yalnizca KALICI HATA olan kayitlar uyari rengiyle
 * gosteriliyor.
 */
function BaglantiSeridi({
  hata,
  cevrimici,
  onbellekten,
  bekleyen,
  hatali,
}: {
  hata: string | null;
  cevrimici: boolean;
  /** Okumalar sunucuya ulaşılamadığı için önbellekten döndü (`pwa-onbellek.ts`). */
  onbellekten: boolean;
  bekleyen: number;
  hatali: number;
}) {
  /*
    ÇEVRİMDIŞI = arayüz kapalı YA DA okumalar önbellekten geliyor —
    UI/UX Dalga 1 (Ö9). Yalnız `navigator.onLine`a bakınca sunucuya
    ulaşamayan ağda şerit hiç çıkmıyor, ekran eski veriyle güncel
    görünüyordu. Metin öğrencinin diliyle ("sen") ve önce DURUM, sonra
    bekleyen sayısı: "Çevrimdışısın · 2 sonuç gönderilmeyi bekliyor".
  */
  const cevrimdisi = !cevrimici || onbellekten;
  if (!cevrimdisi && bekleyen === 0 && hatali === 0 && !hata) return null;

  const parcalar: string[] = [];
  if (cevrimdisi) parcalar.push("Çevrimdışısın");
  if (bekleyen > 0) parcalar.push(`${bekleyen} sonuç gönderilmeyi bekliyor`);
  if (hatali > 0) parcalar.push(`${hatali} sonuç gönderilemedi`);
  if (onbellekten) parcalar.push("son kaydedilen bilgiler gösteriliyor");

  return (
    <p
      role="status"
      className={cn(
        "rounded-alan mt-2 px-3 py-1.5 text-xs",
        hatali > 0
          ? "bg-hata-500/10 text-hata-700"
          : cevrimdisi
            ? "bg-notr-800 text-notr-0 font-medium"
            : "bg-notr-100 text-notr-600",
      )}
    >
      {parcalar.join(" · ")}
      {cevrimdisi && bekleyen > 0 && ". Bağlanınca kendiliğinden gönderilecek."}
      {hata && ` ${hata}`}
    </p>
  );
}
